import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class DataListService {

    private currentResultSet: any[] = [];
    private currentResultStream: BehaviorSubject<any[]> = new BehaviorSubject(new Array<any>());

    private currentStartChunk = 0;
    private chunkSize = 10;
    private stepSize = 1;

    GetNextChunk(): void {
        if (this.currentStartChunk + this.stepSize >= this.currentResultSet.length) {
            this.currentStartChunk = this.currentResultSet.length - this.stepSize;
        } else {
            this.currentStartChunk += this.stepSize;
        }
        this.SendChunk();
    }
    GetPrevChunk(): void {
        if (this.currentStartChunk - this.stepSize <= 0) {
            this.currentStartChunk = 0;
        } else {
            this.currentStartChunk -= this.stepSize;
        }
        this.SendChunk();
    }
    IsFirstChunk(): boolean {
        return (this.currentStartChunk === 0);
    }

    SetResultSet(result: any[]): void {
        // deep copy
        this.currentResultSet = JSON.parse(JSON.stringify(result));

        this.currentStartChunk = 0;

        this.SendChunk();
    }

    SendChunk(): void {
        const chunk = this.currentResultSet.slice(this.currentStartChunk, this.currentStartChunk + this.chunkSize);

        // wyslanie do zczytania
        this.currentResultStream.next(chunk);
    }

    GetResultSet(): Observable<any[]> {
        return this.currentResultStream.asObservable();
    }
}
